import { isEmpty } from 'lodash';

export const DEAddressMapper = (storeAddress) => {
  if (storeAddress?.CountryCode !== 'DE') {
    return {
      street: '',
      number: '',
      postCode: '',
      city: '',
    };
  }

  if (isEmpty(storeAddress?.AddressFields)) {
    return {
      street: storeAddress?.Line1 || '',
      number: '',
      postCode: storeAddress?.Postcode || '',
      city: storeAddress?.City || '',
    };
  }

  return storeAddress.AddressFields;
};
